import React from 'react';
import { useTranslation, Trans } from 'react-i18next';
import { Url } from '@wix/da-url';
import PaywallLayout from '../PaywallLayout';
import Button from '../../../../../Button';
import BiLink from '@wix/da-bi/pkg/Components/BiLink';
import { BiData, BiContextProvidedValue } from '@wix/da-bi/pkg/events';
import Points from '@wix/da-ds/pkg/Icons/Points';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import { normalizePremiumFolderData } from '../../../../../utils/normalizePremiumFolderData';
import { getDeviationResourceType, isVideoDeviation } from '../../../../_helpers';
import paywallStyles from '../Paywall.scss';
const PremiumFolderPaywall = ({ deviation, width, height })=>{
    var _deviation_author;
    const { t } = useTranslation();
    const { folderId, folderUrl, pointPrice, formattedDollarPrice, subproductId } = normalizePremiumFolderData(deviation === null || deviation === void 0 ? void 0 : deviation.premiumFolderData);
    const isVideo = isVideoDeviation(deviation);
    return /*#__PURE__*/ React.createElement(PaywallLayout, {
        deviation: deviation,
        icon: /*#__PURE__*/ React.createElement("div", {
            className: paywallStyles['premium-folders-icon']
        }),
        title: t('deviationview.paywall.artstage.premiumFolder.title'),
        text: isVideo ? /* prettier-ignore */ /*#__PURE__*/ React.createElement(Trans, {
            i18nKey: "deviationview.paywall.artstage.premiumFolder.text.video"
        }, "To watch, unlock its", /*#__PURE__*/ React.createElement(BiLink, {
            className: paywallStyles['folder-preview-button'],
            href: folderUrl
        }, "Premium Folder"), "and support the artist!") : /* prettier-ignore */ /*#__PURE__*/ React.createElement(Trans, {
            i18nKey: "deviationview.paywall.artstage.premiumFolder.text"
        }, "To view, unlock its", /*#__PURE__*/ React.createElement(BiLink, {
            className: paywallStyles['folder-preview-button'],
            href: folderUrl
        }, "Premium Folder"), "and support the artist!"),
        button: /*#__PURE__*/ React.createElement(Button, {
            view: "b18",
            height: "medium",
            fullWidth: false,
            href: subproductId ? Url.checkoutLink(subproductId) : undefined,
            biData: BiData({
                evid: 361,
                typeid: getDeviationResourceType(deviation),
                itemid: deviation.deviationId,
                authorid: (_deviation_author = deviation.author) === null || _deviation_author === void 0 ? void 0 : _deviation_author.useridUuid,
                galleryid: folderId !== null && folderId !== void 0 ? folderId : 0,
                points: pointPrice,
                rank: BiContextProvidedValue,
                reason_shown: BiContextProvidedValue,
                section_typeid: BiContextProvidedValue,
                sectionid: BiContextProvidedValue,
                sectionname: BiContextProvidedValue,
                sectionrank: BiContextProvidedValue,
                sectiontype: BiContextProvidedValue,
                sort_type: BiContextProvidedValue,
                widgetname: BiContextProvidedValue
            })
        }, `Unlock for ${formattedDollarPrice} / `, /*#__PURE__*/ React.createElement(Points, {
            className: paywallStyles['points-icon'],
            size: IconSize.TINY,
            disableDefaultColors: true
        }), `${pointPrice}`),
        width: width,
        height: height
    });
};
PremiumFolderPaywall.displayName = 'PremiumFolderPaywall';
export default PremiumFolderPaywall;

//# sourceMappingURL=PremiumFolderPaywall.js.map